import React from 'react';

import { Dialog, DialogContent } from '@mui/material';
import { DialogHeading } from 'components/dialog-title';
import { GridUserPatientProfileSubscriptionActivities } from '../grid';
import style from './index.module.scss';
import { useTranslate } from 'hooks/use-translate';

import { ignoreEscapeKeyDown } from 'utils/handlers';

const defaultRefresh = () => {};

interface Props {
  userPatientProfileSubscriptionID: string;
  onClose: () => void;
  onRefresh?: () => void;
}

export const DialogUserPatientProfileSubscriptionActivities: React.FC<
  React.PropsWithChildren<Props>
> = ({ userPatientProfileSubscriptionID, onClose, onRefresh = defaultRefresh }) => {
  const { t } = useTranslate();

  return (
    <Dialog
      open={true}
      onClose={ignoreEscapeKeyDown(onClose)}
      fullWidth
      maxWidth="xl"
      classes={{
        paper: style.paper,
      }}
    >
      <DialogHeading title={t('activities')} onClose={onClose} />
      <DialogContent className={style.content}>
        <GridUserPatientProfileSubscriptionActivities
          className={style.grid}
          userPatientProfileSubscriptionID={userPatientProfileSubscriptionID}
          onRefresh={onRefresh}
        />
      </DialogContent>
    </Dialog>
  );
};
